export default __webpack_public_path__ + "static/media/photo--lg--janie.23265972.jpg";